<template>
    <v-form>
      <v-row align="center" justify="center">
          <h3><b>{{$t('json.endpointsettings')}}</b></h3>
      </v-row>
      <v-row align="center" justify="center">
        <v-col :cols="7">
          <v-text-field v-show="!expanded" autocomplete="off"  @change="onChange" :label="$t('json.endpointurl')" v-model="EndpointSettings.Endpoint" :rules="[() => !!EndpointSettings.Endpoint || $t('json.ruleempty')]" required validate-on-blur ></v-text-field>
          <v-text-field v-show="!expanded" autocomplete="off" @change="onChangeEUser" :label="$t('json.endpointuser')" v-model="endpointUser" required validate-on-blur ></v-text-field>
          <v-text-field v-show="!expanded" autocomplete="off" @change="onChangeEPass" :label="$t('json.endpointpass')" @click:append="EndpointSettings.showPass = !EndpointSettings.showPass" :append-icon="useAppendIconEndpoint" :type="EndpointSettings.showPass ? 'text' : 'password'" v-model="endpointPass" required validate-on-blur ></v-text-field>
          <!-- <v-text-field v-show="!expanded" autocomplete="off" @change="onChangeEUser" :label="$t('json.endpointuser')" v-model="endpointUser" :rules="[(v) => !!v || $t('json.ruleempty')]" required validate-on-blur ></v-text-field>
          <v-text-field v-show="!expanded" autocomplete="off" @change="onChangeEPass" :label="$t('json.endpointpass')" @click:append="EndpointSettings.showPass = !EndpointSettings.showPass" :append-icon="useAppendIconEndpoint" :type="EndpointSettings.showPass ? 'text' : 'password'" v-model="endpointPass" :rules="[(v) => !!v || $t('json.ruleempty')]" required validate-on-blur ></v-text-field> -->
          <v-btn v-show="!expanded" :disabled="EndpointSettings.Endpoint.trim().length === 0" @click="saveEndpointUP" color="primary" block>{{ $t('json.saveup') }}</v-btn>
          <v-text-field v-show="expanded" :disabled="disable || preview" @change="onChange" :label="'Endpoint'" v-model="EndpointSettings.Endpoint" ></v-text-field>
          <v-text-field v-show="expanded" :disabled="disable || preview" @change="onChange" :label="'Type'" v-model="EndpointSettings.Type" ></v-text-field>
          <v-text-field v-show="expanded" :disabled="disable || preview" @change="onChange" :label="'SessionID'" v-model="EndpointSettings.SessionID" ></v-text-field>
          <v-text-field v-show="expanded" :disabled="disable || preview" @change="onChange" :label="'AUTH'" v-model="EndpointSettings.AUTH" ></v-text-field>
          <v-text-field v-show="expanded" :disabled="disable || preview" @change="onChange" :label="'Headers'" v-model="EndpointSettings.Headers" ></v-text-field>
          <v-switch v-show="expanded" :disabled="disable || preview" @change="onChange" :label="'ConfirmDialog'" v-model="EndpointSettings.ConfirmDialog" ></v-switch>
          <v-switch :disabled="disable || preview" @change="onChange" :label="$t('json.export_skip')" v-model="EndpointSettings.SkipExportSettings"></v-switch>
        </v-col>
      </v-row>
    </v-form>
</template>

<script>
export default {
  name: 'SimEndpointSettings',
  props: {
    EndpointSettings: {
      type: Object
    },
    expanded: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      endpointUser: '',
      endpointPass: '',
      initedEndpointPass: false
    }
  },
  computed: {
    useAppendIconEndpoint () {
      if (this.initedEndpointPass) return undefined
      return this.EndpointSettings.showPass ? 'mdi-eye' : 'mdi-eye-off'
    }
  },
  mounted () {
    if (this.EndpointSettings.PasswordCrypt !== '' && !this.expanded) {
      const crypto = atob(this.EndpointSettings.PasswordCrypt)
      this.endpointUser = crypto.substring(0, crypto.indexOf(':'))
      this.endpointPass = crypto.substring(crypto.indexOf(':') + 1)
      if (this.endpointPass) this.initedEndpointPass = true
      // console.log(this.simUser, this.simPass)
    }
  },
  methods: {
    async onChangeEUser (val) {

    },
    async onChangeEPass (val) {
      if (!this.endpointPass) {
        this.initedEndpointPass = false
      }
    },
    async saveEndpointUP () {
      // if (!this.endpointUser || this.endpointUser.trim().length === 0) { return }
      // if (!this.endpointPass || this.endpointPass.trim().length === 0) { return }
      // this.EndpointSettings.UserName = this.endpointUser
      // this.EndpointSettings.Password = this.endpointPass
      if (this.endpointUser.trim().length === 0 && this.endpointPass.trim().length === 0) {
        this.EndpointSettings.PasswordCrypt = btoa('')
      } else {
        this.EndpointSettings.PasswordCrypt = btoa(this.endpointUser + ':' + this.endpointPass)
      }
      this.$emit('changeSettings')
    },
    async onChange (val) {
      console.log('onChange', val)
      this.$emit('changeSettings')
    }
  }
}
</script>
